import Config from "../../common/config/config";

export default class Branch {
    constructor(books, index, grade, isTitle) {
        this.books = books;
        this.index = index;
        this.grade = grade;
        this.isTitle = isTitle;
        this.typeIndex = ((this.index - 1) % 8) + 1;
        this._init();
    }

    update() {
        //const sy = window.pageYOffset;
        //const oy = this.$self.getBoundingClientRect().top + sy;
        //const triggerpos = sy + window.innerHeight;

        if (!this.$self.classList.contains("-active")) {
            //if(triggerpos >= oy){
            this._attention();
            this.$self.classList.add("-active");
            //}
        }
    }

    _init() {
        this.nowIndex = -1;

        this.$inner = document.querySelector(".js-main-inner-sp");
        this.$self = null;
        this.$books = null;
        this._create();
        this._ui();
    }

    _create() {
        // const tag = `
        //     <div class="branches -type${this.typeIndex} -branch${this.index} -${this.grade}">
        //         <div class="branches__animal -animal1"><span></span></div>
        //         <div class="branches__animal -animal2"><span></span></div>
        //         <div class="branches__animal -animal3"><span></span></div>
        //         ${this._getTitleTag()}
        //         <div class="branches__bg"></div>
        //         <div class="branches__main">
        //             ${this._getBooksTag()}
        //         </div>
        //     </div>`;

        const tag = `
            <div class="branches -type${this.typeIndex} -branch${this.index} -${this.grade}">
                <div class="branches__animal -animal1"><span></span></div>
                ${this._getTitleTag()}
                <div class="branches__bg"></div>
                <div class="branches__main">
                    ${this._getBooksTag()}
                </div>
            </div>`;

        this.$inner.insertAdjacentHTML("beforeend", tag);
        this.$self = this.$inner.lastElementChild;
        this.$main = this.$self.querySelector(".branches__main");
        this.items = this.$self.querySelectorAll(".branches__item");
    }

    _getTitleTag() {
        // spでは方向を分けない
        if (!this.isTitle) return "";
        // const vect = (this.index%2 == 0) ? 'l' : 'r';
        // return `<h3 class="branches__title -${this.grade}" id="scr-${this.grade}"><span><img src="${Config.image_dir}top/main/title_${this.grade}_${vect}.png" alt=""></span></h3>`;
        return `<h3 class="branches__title -${this.grade}" id="scr-${this.grade}-sp"><span><img src="${Config.image_dir}top/main/title_${this.grade}.png" alt=""></span></h3>`;
    }

    _getBooksTag() {
        let tags = "";

        for (let i = 0; i < this.books.length; i++) {
            tags += `
                <div class="branches__item -item${i + 1}" data-index="${i}">
                    <div class="branches__item__book"><img src="${this.books[i]._bookFile}" alt="${this.books[i]._title}"></div>
                    <div class="branches__item__ba js-ba">
                        <div class="branches__item__ba__main">
                            <div class="branches__item__ba__inner"><p class="branches__item__ba__text">${this._getBaText(this.books[i])}</p></div>
                        </div>
                    </div>
                </div>`;
        }

        return tags;
    }

    _getBaText(book) {
        if (book._usrDatas.length == 0) return "";

        let text = book._usrDatas[0]["感想"].trim();
        if (text.length > 20) text = `${text.substr(0, 17)}...`;
        return text;
    }

    _ui() {
        [...this.$self.querySelectorAll(".branches__item")].forEach(($book) => {
            $book.addEventListener("click", () => {
                const data = this.books[$book.getAttribute("data-index")];
                window.manabiKansoSP.show(data, this.grade);
            });
        });
    }

    /**
     * 定期的なアテンション処理
     * @param _delay {number}
     */
    _attention(_delay) {
        let delay = _delay ? _delay : 0;

        this.nowIndex = Math.floor(Math.random() * this.items.length);
        const $target = this.items[this.nowIndex];

        if ($target.classList.contains("-active")) {
            $target.classList.add("-att");

            setTimeout(() => {
                $target.classList.remove("-att");
            }, 3000);

            if (this.items.length === 1) {
                delay = Math.floor(Math.random() * 2000) + 2500;
            } else {
                delay = Math.floor(Math.random() * 2000) + 2000;
            }
        }

        setTimeout(() => {
            this._attention();
        }, delay);
    }
}
